import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import { SampleNextArrow, SamplePrevArrow } from "../../shared/Arrow";
import { API_URL } from "../../../constants";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { createSearchParams, useNavigate } from "react-router-dom";

const DemandedCity = ({ infoHome }) => {

  const slider1 = useRef();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    dir:"rtl",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true,
        
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
        
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          centerMode: true,
centerPadding: '20%',

        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
centerPadding: '20%',
        }
      }
    ]
  };
  const next = () => {
    slider1.current.slickNext();
  };
  const previous = () => {
    slider1.current.slickPrev();
  };
 const Navigate = useNavigate()
  const gotocat = (city,state) => {
    Navigate({
      pathname: "/categories",
      search: createSearchParams({
        city:city ,
        state:state ,
      }).toString()
    });
 };
  return (
   <div className="DemandedCity">
      <div className="container">
      <div className=" flex justify-between items-center mt-[100px]">
        <div className="title--home">
          <h4 className="font-[700] text-[40px] text-[#292D32]">
            شهر های پر تقاضا{" "}
          </h4>
          <div className="text-[20px] mt-[10px] text-[#797D82] title--home--p">
            بهترین اقامتگاه ها را با مناسب ترین قیمت ها و امکانات رزرو کنید
          </div>
        </div>
        <div className="flex">
          <SampleNextArrow onClick={next} />
          <SamplePrevArrow onClick={previous} />
        </div>
      </div>
      <div className="mt-10 rounded-[30px] DemandedCity-container ">
     {  infoHome ?<Slider ref={slider => (slider1.current = slider)} {...settings}>
          {infoHome?.demand_cities.map(i =>
            <div onClick={()=>gotocat(i.name,i.state)} key={i.id} className="DemandedCity-box">
              <img className="rounded-[50%] w-[131px] h-[113px]" src={`${i.image.path}`} />
              <div className="mt-[16px] mb-[8px] text-[#292D32] text-[20px] whitespace-nowrap">
                <span className=" font-[700] font-[20px]">{i.title}</span>
           ,<span>{i.state}</span> 
              </div>
              <p className="text-[#797D82] text-[16px]">
                اقامتگاه {i.residence_count}
              </p>
            </div>
          )}
        </Slider>: <div className="container" >
            <SkeletonTheme height={200} borderRadius={10}>
              <div className="grid grid-cols-6 gap-[20px]">
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </div>
            </SkeletonTheme>
          </div>}
      </div>
    </div>
   </div>
  );
};

export default DemandedCity;
